/**
 * Ruler tick labels: at most `maxDecimals` places after the decimal, no float noise; drop `.00`
 * and trim trailing zeros (`12.5` not `12.50`).
 */
export function formatRulerTickNumber(value: number, maxDecimals = 2): string {
  if (!Number.isFinite(value)) return ''
  const rounded = Number(value.toFixed(maxDecimals))

  if (!Number.isFinite(rounded)) return ''
  return String(rounded)
}

/** Inches shown on major ticks (distance in pt → in). */
export function formatInchTickLabel(points: number): string {
  return formatRulerTickNumber(points / 72, 2)
}
